<div class="container-fluid">
  <div class="row">
        <!-- Header -->
        <div class="col-12 col-md-12 bgWhite padHeder mobView">
            <div class="col-12 col-md-6 pad0" style="display: inline-block;vertical-align: sub;" >
                <h4 style="display: inline-block;">Settings</h4>
                <span class="btn-blue brdrRadius3"
                    style=" float: right; position: relative; padding: 3px 8px !important; top: 1px;font-size: 13px !important; margin-top: 2px;"
                    (click)="backBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
                </span>
            </div>
        </div>

        <div class="col-12 col-sm-12 bgWhite webView" style="padding: 15px 15px 15px 30px">
            <div class="com-md-9 col-lg-9" style="display: inline-block; padding: 0px;">
                <h3 class="lblHeader newHeader" style="display: inline-block;">
                    Settings
                </h3>
            </div>
            <div class="com-md-3 col-lg-3" style="display: inline-block; text-align: right; padding: 0px;">
                <span class="btn-blue brdrRadius3"
                    style="font-size: 13px; display: inline-block; padding: 4px 12px 4px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Return to Accounts
                </span>
            </div>
        </div>
        <div class="col-md-12 col-12 col-sm-12 leftPad">
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0" *ngIf="false">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="open('Customer')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Customer Default Group</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Select the Account Group where your customers' ledgers will be saved.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0" *ngIf="false">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="open('Supplier')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Supplier Default Group</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Select the Account Group where your suppliers' ledgers will be saved.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="open('DeLink')">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">Accounting in Documents</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Control whether accounting entries (vouchers) are created when you generate invoices and other documents.</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-3 col-12 col-sm-12 width25 padLft0">
                <div class="row padZero alignClass" style="margin: 0px;">
                    <div class="dashBox dashBox-stats brdrRadius3" style="margin-top: 10px;" (click)="openGSTLedgerModal()">
                        <div class="dashBox-coloured-header brdrRadius3 gradDrkBlueBkgd">
                            <h3 class="dashBox-title ellipsis" style="font-size: 17px;">GST Ledgers</h3>
                        </div>
                        <div>
                            <p class="dashBox-category overrideDescriptionBottomCard reportDesc"
                                style="line-height: 22px;">Configure GST ledgers for sales and purchase transactions.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate"></ngx-spinner>